import {objectHasProperty} from "../Types/objectUtilities";

export interface SearchModel {
    pageId: string;
    page: number;
    loadSearchResults: boolean;
    recordsPerPage: number;
    sortByColumn: string;
    sortDescending: boolean;
    baseSortByColumn: string;
    ClearSearch: (loadSearchResults?: boolean) => void;
    UpdateSorting: (columnId: string) => void;
    First: () => void;
    Last: (totalRecords: number) => void;
    Next: () => void;
    Previous: () => void;
    Search: (searchInfo: Record<string, unknown>) => void;
    [key: string]: unknown;
}

export const searchModel = (
    pageId: string,
    defaultSortByColumn: string,
    loadSearchResults = false,
    baseSortByColumn = "",
    recordsPerPage = 25,
): SearchModel => ({
    pageId: pageId || "",
    page: 1,
    loadSearchResults: loadSearchResults,
    recordsPerPage: recordsPerPage,
    sortByColumn: defaultSortByColumn || "",
    sortDescending: false,
    baseSortByColumn: baseSortByColumn || "",
    ClearSearch: clearSearch,
    UpdateSorting: updateSorting,
    First: first,
    Last: last,
    Next: next,
    Previous: previous,
    Search: search,
});

function clearSearch(this: SearchModel, loadSearchResults = true): void {
    this.page = 1;
    this.loadSearchResults = loadSearchResults;
}

function search(this: SearchModel, searchInfo: Record<string, unknown>): void {
    for (let property in searchInfo) {
        if (objectHasProperty(searchInfo, property) && objectHasProperty(this, property)) {
            this[property] = searchInfo[property];
        }
    }
    this.ClearSearch();
}

function updateSorting(this: SearchModel, columnId: string): void {
    if (this.sortByColumn === columnId) {
        this.sortDescending = !this.sortDescending;
    } else {
        this.sortDescending = false;
        this.sortByColumn = columnId;
    }
    this.page = 1;
}

function first(this: SearchModel): void {
    this.page = 1;
}

function last(this: SearchModel, totalRecords: number): void {
    this.page = Math.ceil(totalRecords / this.recordsPerPage);
}

function next(this: SearchModel): void {
    this.page = this.page + 1;
}

function previous(this: SearchModel): void {
    this.page--;
}

export const sortSliceSearchData = <T extends Record<string, unknown>>(allData: T[], searchCriteria: SearchModel): T[] => {

let sortProp = searchCriteria.sortByColumn;
let sortDir = searchCriteria.sortDescending ? -1 : 1;

allData.sort(function(a, b) {
    if (sortProp.includes("date")) {
        const firstDate = new Date(a[sortProp] as string);
        const secondDate = new Date(b[sortProp] as string);
        return firstDate > secondDate ? sortDir : secondDate > firstDate ? -1 * sortDir : 0;
    }

    return (a[sortProp] as string) > (b[sortProp] as string) ? sortDir : (b[sortProp] as string) > (a[sortProp] as string) ? -1 * sortDir : 0;
});

    let recordsPerPage = allData.length;
    if (searchCriteria.recordsPerPage !== null) recordsPerPage = searchCriteria.recordsPerPage;

    const skip = (searchCriteria.page - 1) * recordsPerPage;
    const take = recordsPerPage + skip;

    return allData.slice(skip, take);
};
